export const CUIT_CUIL_LENGTH = 11;
export const DNI_LENGTH = 8;
export const DELIVERY_TYPE = 1
export const PICK_UP_TYPE = 2
export const STORE_ID_DEFAULT = '2';
export const MAX_PRODUCT_CANT = 5;
